import React from 'react';

import {
  AgroOverviewLocation,
  RiskLevel,
} from 'types/Meteorology/Agro/Overview/Dashboard';
import {
  RISK_COLOR,
  RISK_LABEL,
  removerSufixoUf,
} from 'helper/Meteorology/Agro/Overview/locationsTable';

import './index.scss';

const DASH = '—';

// Mesmas cores dos badges de risco do desktop (SummaryCards/index.scss).
const RISK_CLASS: Record<RiskLevel, string> = {
  baixo: 'risk-low',
  moderado: 'risk-mid',
  alto: 'risk-high',
  muito_alto: 'risk-very-high',
};

function metric(value: number | null, unit = ''): string {
  if (value === null || value === undefined) return DASH;
  return unit ? `${value}${unit}` : `${value}`;
}

function Chip({
  label,
  value,
  negative,
}: {
  label: string;
  value: string;
  negative?: boolean;
}) {
  return (
    <div className="agro-overview-mobile-location-chip">
      <span className="agro-overview-mobile-location-chip-label">{label}</span>
      <span
        className={`agro-overview-mobile-location-chip-value${negative ? ' negative' : ''}`}
      >
        {value}
      </span>
    </div>
  );
}

export default function LocationCard({
  location,
  onClick,
}: {
  location: AgroOverviewLocation;
  onClick: () => void;
}) {
  const name = location.estado
    ? removerSufixoUf(location.nome, location.estado)
    : location.nome;
  const subtitle = location.estado ? `${location.estado} · Brasil` : 'Brasil';
  const risco = location.risco7d;
  const deficitNegative = location.perdaAgua7dMm !== null && location.perdaAgua7dMm < 0;

  return (
    <button
      type="button"
      className="agro-overview-mobile-location-card"
      aria-label={name}
      onClick={onClick}
    >
      <div className="agro-overview-mobile-location-head">
        <span className="agro-overview-mobile-location-identity">
          <span
            className="agro-overview-mobile-location-dot"
            style={risco ? { backgroundColor: RISK_COLOR[risco] } : undefined}
          />
          <span className="agro-overview-mobile-location-name">{name}</span>
        </span>
        <span
          className={`agro-overview-mobile-location-badge${risco ? ` ${RISK_CLASS[risco]}` : ''}`}
        >
          {risco ? RISK_LABEL[risco] : DASH}
        </span>
      </div>
      <span className="agro-overview-mobile-location-subtitle">{subtitle}</span>
      <div className="agro-overview-mobile-location-chips">
        <Chip label="Dias s/ chuva" value={metric(location.diasSemChuva)} />
        <Chip label="ARM" value={metric(location.armPct, '%')} />
        <Chip label="Chuva prev." value={metric(location.chuva7dMm, ' mm')} />
        <Chip
          label="Déficit"
          value={metric(location.perdaAgua7dMm, ' mm')}
          negative={deficitNegative}
        />
      </div>
    </button>
  );
}
